import styled from 'styled-components';

import { HTMLAttributes } from 'react';
import { Colors } from '../types';

export const StyledLoader = styled.svg<{ $color?: Colors; $size?: number } & HTMLAttributes<SVGElement>>`
    overflow: hidden;
    width: ${({ $size }) => $size + 'px'};
    height: ${({ $size }) => $size + 'px'};

    path {
        fill: ${({ theme, $color }) => theme[$color || 'primary-default']};
    }
`;
